/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useRef, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { Box, fade } from '@material-ui/core';
import DateNavigatorReports from '../../components/filters/DateNavigatorReports';
import { bgimage } from '../constants';
import PageLayout from '../shared/PageLayout';
import TabsList from '../components/TabsList';
import useCompany from '../../hooks/useCompany';
import Invoices from './TadweenInvoices';
import Receipt from './TadweenReceipt';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import Subscribtions from './Subscribtions';

export default function TadweenOperations({
  isRTL,
  words,
  theme,
  menuitem,
  formgroup,
  drawerWidth,
}: any) {
  const [start, setStart] = useState<any>(null);
  const [end, setEnd] = useState<any>(null);

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const invoiceref: any = useRef();
  const receiptref: any = useRef();
  const customerref: any = useRef();

  const [currentViewName, setCurrentViewName] = useState('Month');
  const [currentDate, setCurrentDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const { height, width } = useWindowDimensions();
  const { company } = useCompany();

  const currentViewNameChange = (e: any) => {
    setCurrentViewName(e.target.value);
  };

  const currentDateChange = (curDate: any) => {
    setCurrentDate(curDate);
  };

  const endDateChange = (curDate: any) => {
    setEndDate(curDate);
  };

  const handleSelect = (item: any) => {
    navigate(item?.path);
  };

  const refresh = () => {
    if (pathname?.includes('invoices')) {
      invoiceref?.current?.refresh();
    }
    if (pathname?.includes('receipts')) {
      receiptref?.current?.refresh();
    }
    if (pathname?.includes('customers')) {
      customerref?.current?.refresh();
    }
  };

  const bgcolor = '#23A46C08';

  return (
    <PageLayout
      menuitem={menuitem}
      isRTL={isRTL}
      words={words}
      theme={theme}
      refresh={refresh}
      bgcolor={bgcolor}
      bgimage={bgimage}
      width={width - drawerWidth}
    >
      <Box
        style={{
          height: height - 50,
          overflow: 'auto',
        }}
      >
        <Box
          display="flex"
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginRight: 50,
            marginLeft: 50,
            marginTop: 5,
          }}
        >
          <DateNavigatorReports
            setStart={setStart}
            setEnd={setEnd}
            currentDate={currentDate}
            currentDateChange={currentDateChange}
            currentViewName={currentViewName}
            currentViewNameChange={currentViewNameChange}
            endDate={endDate}
            endDateChange={endDateChange}
            views={[1, 7, 30, 365, 1000]}
            isRTL={isRTL}
            words={words}
            theme={theme}
          ></DateNavigatorReports>
        </Box>
        <Paper
          elevation={5}
          style={{
            borderRadius: 25,
            margin: 25,
            marginTop: 5,
            width: width - drawerWidth - 50,
            height: height - 135,
          }}
        >
          <TabsList
            handleSelect={handleSelect}
            isRTL={isRTL}
            list={formgroup}
            theme={theme}
            width={width - drawerWidth - 50}
            color={fade(theme?.palette?.secondary?.main, 0.2)}
            pathname={pathname}
          ></TabsList>
          <Paper
            style={{
              display: 'flex',
              height: height - 185,
              overflow: 'auto',
              borderBottomLeftRadius: 25,
              borderBottomRightRadius: 25,
            }}
          >
            <Routes>
              <Route
                index
                element={<Navigate to={formgroup?.[0]?.path} replace />}
              />
              <Route
                path={'subscribtions'}
                element={
                  <Subscribtions
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                    drawerWidth={drawerWidth}
                  ></Subscribtions>
                }
              />
              <Route
                path={'invoices'}
                element={
                  <Invoices
                    ref={invoiceref}
                    start={start}
                    end={end}
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                    company={company}
                    drawerWidth={drawerWidth}
                  ></Invoices>
                }
              />
              <Route
                path={'receipts'}
                element={
                  <Receipt
                    ref={receiptref}
                    start={start}
                    end={end}
                    isRTL={isRTL}
                    words={words}
                    theme={theme}
                    company={company}
                    drawerWidth={drawerWidth}
                  ></Receipt>
                }
              />
            </Routes>
          </Paper>
        </Paper>
      </Box>
    </PageLayout>
  );
}
